import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/Exam.es.js";
const a = o.forwardRef((m, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...m, weights: t }));
a.displayName = "ExamIcon";
const n = a;
export {
  n as Exam,
  a as ExamIcon
};
